import catalogue from '../../../language/menuElakay_en.json';

const tokenLabels = { loading: 'loading', myQr: 'myQr', sellerToken: 'sellerPromotion', providerToken: 'providerPromotion', simplePromotion: 'simplePromotion' };
export const dashboardText = infoSource => key =>
  (tokenLabels[key] && (infoSource?.laguangeElakay?.('roleChangeRequest', infoSource.languageAPI)?.roleTokens?.[tokenLabels[key]]
    || catalogue[0].roleChangeRequest.roleTokens[tokenLabels[key]]))
  ||
  infoSource?.laguangeElakay?.('associateDashboard', infoSource.languageAPI)?.[key]
  || catalogue[0].associateDashboard?.[key] || key;
